import { isWorkerUrl } from "@viewer-quality";

/** Build an authed text fetcher for Worker manifest URLs. The HLS master and
 *  variant playlists live behind the Worker /api routes and need the team JWT;
 *  the segments they reference are presigned R2 URLs fetched separately.
 *  The token goes to `workerOrigin` and nowhere else: a URL on any other
 *  origin is fetched without it. */
export function makeFetchManifest(
  token: string | null,
  workerOrigin: string,
): (url: string) => Promise<string> {
  return async (url: string): Promise<string> => {
    const authed = token != null && isWorkerUrl(url, workerOrigin);
    const res = await fetch(url, {
      headers: authed ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error(`manifest fetch failed: HTTP ${res.status}`);
    return res.text();
  };
}
